import styled from "@emotion/styled";
import { Box, LinearProgress, TableCell, TableRow } from "@mui/material";
import { tableCellClasses } from '@mui/material/TableCell';


export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#012A52',
    //@ts-ignore
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#E5E8EC',
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export const TableContainer = styled(Box)({
  maxWidth: '100%',
  width: '100%',
  height: '100%',
  background: 'white',
  boxShadow: '0px 1px 8px rgba(0, 0, 0, 0.12)',
  borderRadius: 5,
  padding: 20,
  paddingLeft: 20,
  paddingTop: 1,
  marginTop: 20,
});

const TableLinearProgress = styled(LinearProgress)(() => ({
  height: 10,
  borderRadius: 5,
  padding: "4px 4 4 4"
}));

export const TableLoadingRow = ({ colSpan }: { colSpan: number }) => <StyledTableRow>
  <StyledTableCell colSpan={colSpan} sx={{ paddingTop: 1, paddingBottom: 1, px: 0.5 }} style={{ height: 20 }}>
    <TableLinearProgress />
  </StyledTableCell>
</StyledTableRow>